import { Empty, Select, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useState } from "react";
import LookupTable from "../../../../redux/models/lookupTable";
import K from "../../../../utilities/constants";

const N_A_VALUE = -1;

export const JobDepartmentSelector = ({
  clientId,
  value,
  onChange,
  ...props
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleDropdownVisibleChange = async (open) => {
    if (open && !options.length && clientId) {
      try {
        setLoading(true);
        const data = await LookupTable.getJobDepartmentByMultipleClient(
          { clientIds: [clientId] },
          false,
        );

        const departmentOptions = data.map(({ id, name }) => ({
          value: id,
          label: name,
        }));

        setOptions([
          { value: N_A_VALUE, label: K.NullPlaceholder },
          ...departmentOptions,
        ]);
      } catch (err) {
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Select
      showSearch
      allowClear
      placeholder="Select Department"
      options={options}
      value={value}
      onChange={onChange}
      labelInValue
      optionFilterProp="label"
      style={{ width: "100%" }}
      notFoundContent={
        loading ? (
          <Spin indicator={<LoadingOutlined spin />} />
        ) : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )
      }
      onDropdownVisibleChange={handleDropdownVisibleChange}
      disabled={!clientId}
      {...props}
    />
  );
};
